
import axios from "axios"
import router from '../../router';

import { func } from '../../main';

const state = {
    NoticeMessageList: [],
    Loading:false
};


const getters = {
    GetNoticeMessageList(state: { NoticeMessageList: any; }) {
        return state.NoticeMessageList;
    }
};

const mutations = {

    SetNoticeMessageList(state: { NoticeMessageList: any; }, list: any) {
        state.NoticeMessageList = list;
    }

};

const actions = {
    GetNoticeMessageListFromServer(context: { commit: (arg0: string, arg1: any) => void; }) {
        axios.get("TaskOnline/GetNoticeMessage", {
        })
            .then((data: any) => {
                context.commit("SetNoticeMessageList", data.data);
            });
    },
};

export default {
    state,
    getters,
    mutations,
    actions
};
